import React from 'react'
import { Form, Input, Button } from 'antd'
import { SafetyCertificateOutlined } from '@ant-design/icons'


export default function CaptchaMsg(props) {
    const { btnDisabled, btnText, sendMessage } = props
     
    return (
        <div id='MessageCode'>
            <Form.Item
                name="MessageCode"
                // validateTrigger="onBlur"
                hasFeedback={true}
                rules={[
                    {
                    required: true,
                    message: '请输入短信验证码！',
                    }
                ]}
            >
                <Input prefix={<SafetyCertificateOutlined className="site-form-item-icon" />} placeholder="验证码"/>
            </Form.Item>
            <Button onClick={sendMessage} disabled={btnDisabled}>{btnText}</Button>
        </div>
    )
}
